import React, { Component } from 'react';
import { 
  Button as KendoButton, 
  ButtonProps 
} from '@progress/kendo-react-buttons';

class CustomButton extends Component<ButtonProps> {
  render() {
    return (
      <KendoButton {...this.props}>
        {this.props.children}
      </KendoButton>
    );
  }
}

export default CustomButton;
